import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import BtnLoader from "./BtnLoader";
import { BASE_URL } from "..";
import { SIGNUP_API } from "../app/constants";
import Notification from "../helper/Notification";

const SignUpSection = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isMessage, setIsMessage] = useState(null); // For success or error message
  const [showNotification, setShowNotification] = useState(false); // Toggle for notification visibility
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm();

  const phoneNumber = sessionStorage.getItem("phoneNumber");

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      const payload = {
        ...data,
        phoneNumber: phoneNumber,
      };
      const response = await axios.post(`${BASE_URL}${SIGNUP_API}`, payload);
      console.log("Server Response:", response.data);
      if (response.status === 200 && response.data.code === 1) {
        sessionStorage.setItem("email", response.data.data.user.email);
        sessionStorage.setItem("name", response.data.data.user.name);
        localStorage.setItem("accessToken", response.data.data.token);
        setIsMessage("Signup successful! Redirecting...");
        setShowNotification(true);
        navigate("/");
      } else {
        setIsMessage(response.data.message || "Signup failed");
        setShowNotification(true);
      }
    } catch (error) {
      setIsMessage(error.response?.data.message || "An error occurred");
      setShowNotification(true);
      console.error("Error during signup:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="flex-center bg-white">
      <Notification
        show={showNotification}
        type="error"
        title="Existing Email Found"
        message={isMessage}
        onClose={() => setShowNotification(false)}
      />
      <div className="container container-lg py-40">
        <form onSubmit={handleSubmit(onSubmit)} className="flex-center">
          <div className="gy-4 overflow-hidden bg-white d-flex flex-column flex-lg-row gap-10">
            {/* Left Side */}
            <div
              className="col-xl-6 p-0 order-lg-1 order-2 flex-center flex-column mt-0"
              style={{
                maxWidth: "26rem",
                minHeight: "33rem",
                background:
                  "linear-gradient(to bottom, #FE5014, #FE5014, #FD9B7B, #FFC6C6)",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            >
              <h4 className="text-capitalize text-white p-20 pt-40">
                Shopping with lowest prices & maximum discounts
              </h4>
              <p className="text-white px-20">
                We are connected with wholesalers to offer the best price on
                every item you buy
              </p>
              <img
                className="mt-40"
                src="assets/images/icon/login-img.png"
                alt="LoginImg"
                style={{ objectFit: "cover" }}
              />
            </div>

            {/* Right Side */}
            <div
              className="p-24 p-md-5 d-flex justify-content-center flex-column order-lg-2 order-1 border-0"
              style={{
                maxWidth: "23rem",
                width: "100%",
              }}
            >
              <div className="hover-border-main-600 transition-1 rounded-16 h-100">
                <div className="flex-center flex-column mb-24">
                  <img
                    style={{ width: "10rem" }}
                    src="assets/images/logo/header_logo.png"
                    alt="Logo"
                  />
                  <p className="text-2xl fw-bolder text-black">Sign Up</p>
                  <p className="text-sm">
                    Create an account to enjoy exclusive offers
                  </p>
                </div>
                <div className="mb-24">
                  <input
                    type="text"
                    className="common-input"
                    style={{ minWidth: "16rem" }}
                    placeholder="Enter your full name"
                    {...register("fullName", {
                      required: "Full Name is required",
                    })}
                  />
                  {errors.fullName && (
                    <p className=" position-absolute text-xs text-danger">
                      {errors.fullName.message}
                    </p>
                  )}
                </div>
                <div className="mb-24">
                  <input
                    type="email"
                    className="common-input"
                    style={{ minWidth: "16rem" }}
                    placeholder="Enter your email"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  {errors.email && (
                    <p className=" position-absolute text-xs text-danger">
                      {errors.email.message}
                    </p>
                  )}
                </div>
                <div className="mb-24 position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="common-input"
                    style={{ minWidth: "16rem" }}
                    id="password"
                    placeholder="Password"
                    {...register("password", {
                      required: "Password is required",
                    })}
                  />
                  <p
                    className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer"
                    onClick={togglePasswordVisibility}
                  >
                    <i
                      className={`bi ${
                        showPassword ? "bi-eye-slash" : "bi-eye"
                      }`}
                    ></i>
                  </p>
                  {errors.password && (
                    <p className=" position-absolute text-xs text-danger">
                      {errors.password.message}
                    </p>
                  )}
                </div>
                <div className="my-24 w-100">
                  <button
                    type="submit"
                    className="w-100 btn py-18 px-40 rounded-0 shadow"
                    style={{ background: "#FE5014" }}
                    disabled={!isValid || isLoading}
                  >
                    {isLoading ? <BtnLoader /> : "Create Account"}
                  </button>
                  <div style={{ minWidth: "24rem" }}></div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default SignUpSection;
